// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36t1R","col":"styles_col__1yhlQ"};